import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-550d0fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ad-info" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "apy-info" }
const _hoisted_7 = { class: "apy-text" }
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apy_label = _resolveComponent("apy-label")!
  const _component_IMG = _resolveComponent("IMG")!

  return (_openBlock(), _createElementBlock("td", {
    valign: "top",
    class: "default-ad",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.trackAdLink(_ctx.ad)), ["prevent"]))
  }, [
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_1, [
            (_ctx.ad.adCopy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.ad.account.name), 1),
                  _hoisted_3,
                  _createElementVNode("span", {
                    innerHTML: _ctx.ad.adCopy
                  }, null, 8, _hoisted_4)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.ad.account.name), 1)
                ]))
          ]),
          _createElementVNode("td", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$filters.percentageFilter(_ctx.ad.account.apy)) + " ", 1),
              _createVNode(_component_apy_label)
            ]),
            _createElementVNode("img", {
              src: _ctx.bankImage,
              alt: _ctx.ad.account.bankName
            }, null, 8, _hoisted_8)
          ])
        ])
      ])
    ]),
    _createVNode(_component_IMG, {
      class: "ad-pixel",
      src: _ctx.$filters.formatTrackingFilter(_ctx.ad.pixel),
      width: "1",
      height: "1",
      alt: ""
    }, null, 8, ["src"])
  ]))
}